import type { ContentfulEntry, ContentfulSocialLinkFields } from '@devtinker/shared';
import { Layout } from '@devtinker/shared';
import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getEntries } from './lib/contentful';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Experiments from './pages/Experiments';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import Projects from './pages/Projects';
import SearchResults from './pages/SearchResults';
import Videos from './pages/Videos';

function App() {
  const [socialLinks, setSocialLinks] = useState<ContentfulEntry<ContentfulSocialLinkFields>[]>([]);

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const links = (await getEntries('socialLinks')) as ContentfulEntry<ContentfulSocialLinkFields>[];
        // Filter only active links
        const activeLinks = links.filter(link => link.fields.active !== false);
        setSocialLinks(activeLinks);
      } catch (error) {
        console.error('Error fetching social links:', error);
      }
    };

    fetchSocialLinks();
  }, []);

  return (
    <Layout socialLinks={socialLinks}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/experiments/*" element={<Experiments />} />
      </Routes>
    </Layout>
  );
}

export default App;
